import { ConfettiColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";
import TileWrapper from "ds/components/Tile/Wrapper";

const DashboardWidgetsVendorMigrationSuccess = () => (
  <TileWrapper justify="center">
    <EmptyState title="You're using all the latest features, enjoy!" icon={ConfettiColored} />
  </TileWrapper>
);

export default DashboardWidgetsVendorMigrationSuccess;
